import SimpleBar from 'simplebar';

window.SimpleBar = SimpleBar;